import { advanceFiltersNormalizer } from '@/helpers/advanceFilters/advanceFiltersNormalizer.helper.ts';
import { LINE_ITEM_FILTER_GROUPS } from '../ListFilters/SearchByFilters/SearchByFilters.tsx';
import { DEFAULT_DEVIATED_LINE_ITEM_STATUS } from '../ListFilters/StatusSelector/StatusSelector.tsx';

import type { DeviatedLineItemsCountRequestBody } from '@/services/lineItem.service';

export function buildDeviatedLineItemsRequestBody(
  advanceFilters: Record<string, any>[] | undefined,
  text?: string
): DeviatedLineItemsCountRequestBody {
  const filtersList = advanceFilters || [];
  const searchByFilters = filtersList.filter(f => LINE_ITEM_FILTER_GROUPS.includes(f.id));
  const accountsFilter = filtersList.find(f => f.id === 'accounts');
  const datesFilter = filtersList.find(f => f.id === 'dates');
  const deviationFilter = filtersList.find(f => f.id === 'deviation');
  const statusFilter = filtersList.find(f => f.id === 'status');

  const normalizedSearchBy = advanceFiltersNormalizer(searchByFilters);
  const filters = Object.fromEntries(
    Object.entries(normalizedSearchBy).map(([key, value]) => [key, String(value).split(',')])
  );

  return {
    accounts: Array.isArray(accountsFilter?.value) ? accountsFilter.value : undefined,
    // DateRange sets beginDate/endDate to null (not undefined) when cleared - normalize here so a
    // cleared picker omits the field instead of sending a null the backend schema rejects as "must
    // be string".
    dateFrom: datesFilter?.value?.beginDate ?? undefined,
    dateTo: datesFilter?.value?.endDate ?? undefined,
    deviation: typeof deviationFilter?.value === 'number' ? deviationFilter.value : undefined,
    filters: {
      ...filters,
      status:
        Array.isArray(statusFilter?.value) && statusFilter.value.length
          ? statusFilter.value
          : DEFAULT_DEVIATED_LINE_ITEM_STATUS
    },
    // JSON body, so unlike the Line Items tab's query-string `name` it is not URI-encoded.
    name: text?.trim() || undefined
  };
}
